module.exports = __webpack_public_path__ + "img/ch6.f64cd6db.png";